import React,{useContext, useEffect} from 'react';
import FilterAndShort from '../../components/filterAndShort/FilterAndShort';
import MainMenu from '../../components/mainMenu/MainMenu';
import LeftSitebarMenu from '../../components/leftSitebarMenu/LeftSitebarMenu';
import RightSitebarMenu from './../../components/rightSitebarMenu/RightSitebarMenu';
import ClipVideos from './ClipVideos/ClipVideos';
import clipIcon from '../../assets/img/forum-imgs/new-discussion-icon.svg';
import closerIcon from '../../assets/img/feed-imgs/navbar/closeicon.svg';
import { ShowHideSitebar } from './../../App';

const Clips = () => {
    const [showHideSidebar, setShowHideSidebar] = useContext(ShowHideSitebar)
    useEffect(()=>{ /** setting the page name for the sidebars of this page to work */
        const setPageName = {...showHideSidebar}
        setPageName.pageName = 'clips';
        setPageName.clips.left = false;
        setPageName.clips.right = false;
        setShowHideSidebar(setPageName)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const closeSidebar =(whichSidebar, status)=>{
        const newStatus = {...showHideSidebar}
        if(whichSidebar === 'left'){
            newStatus.clips.left = status /** changing the page name for left sidebar to toggle */
            setShowHideSidebar(newStatus) /** changing the page name for right sidebar to toggle */
        }
        if(whichSidebar === 'right'){
            newStatus.clips.right = status
            setShowHideSidebar(newStatus)
        }
    }
    return (
        <>
            {/* Main Menu here */}
            <MainMenu></MainMenu>
            {/* Menu bar start here */}
            <div className="container-fluid container-lg">
                <div className="row gap-5 gap-lg-0">
                    {/* Left Site Bar Start here */}
                    <div className={`col-12 col-lg-2  d-lg-block ${showHideSidebar?.clips?.left ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                    <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("left", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <LeftSitebarMenu></LeftSitebarMenu>
                    </div>    
                    {/* left Site Bar End Hre */}
                     <div className="col-lg-6">
                        {/* Add A Clip and Filte section here */}
                        <div className="row my-2">
                            {/* Filter and Short Seciton Component */}
                                <div className="row mb-2 gap-2 gap-lg-0">
                                    <div className="col-12 col-lg-8 col-md-6">
                                        <button className="custm-pill-button-small rounded-pill px-3 py-2 post_btn d-flex align-items-center" type="button"> <img src={clipIcon} alt="" className='me-3' /> Add a Clip</button>
                                    </div>
                                    <div className="col-12 col-lg-4 d-flex justify-content-start justify-content-lg-end align-items-start gap-4">
                                        <FilterAndShort></FilterAndShort>
                                    </div>
                                </div>
                        </div>
                        {/* All Clips Show Here or All Clips render Componets */}
                        <ClipVideos></ClipVideos>
                        
                     </div>
                     <div className={`col-12 col-lg-4  d-lg-block ${showHideSidebar?.clips?.right ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                     <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("right", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <RightSitebarMenu />
                    </div> 
               </div>
            </div>
        </>
    );
};

export default Clips;